import Component from '../colorz/Component';
import Device from '@utils/html/Device';
import {breakpointsApp} from '../colorz/configClrzApp';

export default class Newsletter extends Component {
	onInit(el) {
		this.el = el;
		this.elConsentment = this.el.querySelectorAll('input.js-nl-consentment');
		this.elConsentLabel = this.el.querySelectorAll('.js-nl-consent-label');
		this.elSubmitBtn = this.el.querySelector('.js-nl-submit-btn');
		this.elMailError = this.el.querySelector('.js-nl-mail-error');
		this.elRGPDError = this.el.querySelector('.js-nl-rgpd-error');
		this.elMailInput = this.el.querySelector('.js-nl-input');
		this.elAlreadySub = this.el.querySelector('.js-nl-already-sub');
		this.valideEmail = false;
		this.valideConsent = false;
	}

	onReady() {
		this.manageURLParams();
		this.bindEvents();
	}

	bindEvents() {
		// if press SPACE or ENTER key on label element, toogle input check
		this.elConsentLabel.forEach((element) => {
			element.addEventListener('keyup', (event) => {
				if (event.keyCode === 13 || event.keyCode === 32) {
					element.previousElementSibling.checked =
						!element.previousElementSibling.checked;
				}
			});
		});

		// check if Email input
		this.elMailInput.addEventListener('input', () => {
			if (this.validateEmail(this.elMailInput.value)) {
				this.valideEmail = true;
			} else {
				this.valideEmail = false;
			}
			this.checkRequired();
		});

		// whene change, check if all input are checked
		this.elConsentment.forEach((element) => {
			element.addEventListener('change', () => {
				let box_cheked = 0;
				this.elConsentment.forEach((el) => {
					if (el.checked) box_cheked++;
				});
				this.valideConsent = this.elConsentment.length === box_cheked;
				this.checkRequired();
			});
		});
	}

	manageURLParams() {
		if (window.location.href.includes('form_type=customer')) {
			this.elAlreadySub.classList.remove('u-hidden');
			this.elAlreadySub.classList.add('u-mt-10');

			this.isMobile = Device.width < breakpointsApp.desktop;
			if (this.isMobile) {
				window.scrollTo({
					top: -300,
					left: 0,
					behavior: 'smooth',
				});
			}
		} else if (window.location.href.includes('customer_posted=true')) {
			this.isMobile = Device.width < breakpointsApp.desktop;
			if (this.isMobile) {
				window.scrollTo({
					top: -300,
					left: 0,
					behavior: 'smooth',
				});
			}
		} else {
			this.elAlreadySub.classList.add('u-hidden');
			this.elAlreadySub.classList.remove('u-mt-10');
		}
	}

	checkRequired() {
		if (this.valideEmail && this.valideConsent) {
			this.elSubmitBtn.removeAttribute('disabled');
		} else {
			this.elSubmitBtn.setAttribute('disabled', '');
		}
	}

	validateEmail(email) {
		const re =
			/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}
}
